var map = {
	"./american-express.png": 16727,
	"./diners-club.png": 73084,
	"./elo.png": 5938,
	"./hipercard.png": 71316,
	"./mastercard-maestro.png": 31162,
	"./mastercard.png": 6102,
	"./rede-shop.png": 47283,
	"./sodexo.png": 63198,
	"./sorocred.png": 33165,
	"./ticket-alimentacao.png": 84205,
	"./ticket-restaurante.png": 8371,
	"./visa-electron.png": 91250,
	"./visa-vale.png": 68530,
	"./visa.png": 557,
	"./vr.png": 8218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7100;